module.exports = __webpack_public_path__ + "img/no-permission.64993a35.png";